// extracted by mini-css-extract-plugin
export var cardHeader = "_j1-1";
export var contentCard = "_j1-0";
export var headerActions = "_j1-3";
export var reorderHandle = "_j1-5";
export var titleArea = "_j1-2";
export var titleAreaWithHandle = "_j1-4";